import { Observable } from 'rxjs';

import { ISnListResponse } from '@lib/api';
import { SnMapClusterPoint } from '@lib/api';
import { SnCamera, SnCameraDisposition } from '@lib/api/entities';
import { SnLiveUser } from '@lib/live-tracking/models';

export interface CameraMapQueryParams {
  disposition?: SnCameraDisposition;
  pageMapClustered?: boolean;
  pageMapGridSize?: number;
  pageMapZoomLevel?: number;
  pageMapLeftTop?: string;
  pageMapRightBottom?: string;
  status_In?: string;
  exclude_child_cameras?: boolean;
  camera_group__not_in?: string;
  make__not__in?: string;
  make__in?: string;
}

export interface CameraQueryParams {
  mapQueryParams: Partial<CameraMapQueryParams>;
  cameraGroupFilter?: string;
  maxZoom?: number;
}

export interface CamerasServiceInterface {
  hovered$: Observable<SnCamera>;
  cameraSelected$: Observable<SnCamera>;
  selectedUsers$: Observable<{ users: SnLiveUser[]; channelType: string }>;
  firstTwoClicked$: Observable<void>;
  cameras$: Observable<SnCamera[]>;
  clusteredCameras$: Observable<SnMapClusterPoint[]>;

  getCamera(cameraId: string): Observable<SnCamera>;
  
  initCameras(params: CameraQueryParams): void;
  updateMapBounds(mapQueryParams: Partial<CameraMapQueryParams>, cameraGroupFilter?: string, maxZoom?: number): void;
  
  setClustering(enabled: boolean): void;
  getCamerasParameter(params: string[]): void;
  
  isSkydioCamera(camera: SnCamera | { camera?: SnCamera; make?: string }): boolean;
  
  isDownDroneCamera(camera: SnCamera): boolean;
  
  getPendingCameras(): string[];
  setPendingCameras(cameras: string[]): void;
  
  getCamerasParam(): string;
  
  getClustering(): boolean;

  setDeselectedCameraGroupsParam(value: string): void;
  getDeselectedCameraGroupsParam(): string;

  getNeverClusterMakes(): readonly string[];

  getDescendantRequests(cameras: SnCamera[]): Observable<ISnListResponse<SnCamera>>[];
  
  handleParentCamera(camera: SnCamera): Observable<SnCamera[]>;
  
  dockCameras(cameraIds: string[]): Observable<SnCamera | null>;
  cancelDocking(): void;
  cancelDocking$: Observable<void>;

  emitCameraSelected(camera: SnCamera | null): void;

  emitCameraHovered(camera: SnCamera | null): void;

  emitSelectedUsers(users: SnLiveUser[], channelType: string): void;

  emitFirstTwoClicked(): void;
}

